import React from 'react';
import { translations } from '../translations';

const testimonials = [
    {
        quoteKey: 'testimonials.1.quote',
        nameKey: 'testimonials.1.name',
        positionKey: 'testimonials.1.position',
        image: '/assets/images/testimonial1.jpg'
    },
    {
        quoteKey: 'testimonials.2.quote',
        nameKey: 'testimonials.2.name',
        positionKey: 'testimonials.2.position',
        image: '/assets/images/testimonial2.jpg'
    },
    {
        quoteKey: 'testimonials.3.quote',
        nameKey: 'testimonials.3.name',
        positionKey: 'testimonials.3.position',
        image: '/assets/images/testimonial3.jpg'
    }
];

const Testimonials = ({ language }) => {
    return (
        <section className="testimonials" id="testimonials">
            <div className="section-title">
                <h3 className="chinese-font">{translations[language]['testimonials.title']}</h3>
                <p className="chinese-font">{translations[language]['testimonials.subtitle']}</p>
            </div>
            <div className="testimonials-grid">
                {testimonials.map((testimonial, index) => (
                    <div className="testimonial-card" key={index}>
                        <div className="testimonial-content">
                            <p className="chinese-font">{translations[language][testimonial.quoteKey]}</p>
                        </div>
                        <div className="testimonial-author">
                            <div className="author-avatar">
                                <img src={testimonial.image} alt={translations[language][testimonial.nameKey]}/>
                            </div>
                            <div className="author-info">
                            <h5 className="chinese-font">{translations[language][testimonial.nameKey]}</h5>
                                <p className="chinese-font">{translations[language][testimonial.positionKey]}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Testimonials;
